import {http} from "Services/Http/HttpClient";
import FilterBuilder from "Services/Filters/FilterBuilder";

export const getInscriptionPayments = async (inscriptionId: string, filters: any = {}): Promise<any> => {
    const queryParams = FilterBuilder.hashMapToQueryString(filters)
    const paramsString = queryParams ? '?' + queryParams : ''
    return await http.get(`payment-orders/inscriptions/${inscriptionId}/payments${paramsString}`)
}
